import(/* webpackMode: "eager" */ "/codebuild/output/src2176744316/src/apps/webapp/src/app/global-error.tsx");
